import { useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'

import OutletsList from '../../features/outlets/components/OutletsList'
import Page from '../../features/layout/components/Page'
import NavbarOutletSearch from '../../features/layout/components/main/navBar/NavbarOutletSearch'
import Container from '../../features/layout/components/container/Container'
import ClientAuthContainer from '../../features/auth/components/ClientAuthContainer'
import OutletsListPageSkeleton from '../../features/outlets/components/OutletsListPageSkeleton'
import isAppWhiteLabeled from '../../features/app/utils/isAppWhiteLabeled'
import CompanySignUpURLFilter from '../../features/company/components/CompanySignUpURLFilter'
import { clientContextFetchPendingSelector } from '../../features/clientContext/store/clientContextSelectors'
import useAppSelector from '../../store/hooks/useAppSelector'
import useAppDispatch from '../../store/hooks/useAppDispatch'
import { validatePreSelectedOutlet } from '../../features/outlet/store/outletThunks'
import localStorageUtils from '../../features/app/utils/localStorageUtils'

import styles from './index.module.scss'

function OutletsListPage() {
  const { t } = useTranslation('outlets')

  const dispatch = useAppDispatch()

  const isWhiteLabeled = isAppWhiteLabeled()

  const isClientContextLoading = useAppSelector(
    clientContextFetchPendingSelector,
  )

  useEffect(() => {
    async function validateStoredOutletId() {
      const outletId = localStorageUtils.getItem<string>('preSelectedOutletId')
      if (outletId) {
        try {
          await dispatch(validatePreSelectedOutlet({ outletId })).unwrap()
        } catch (error) {
          localStorageUtils.removeItem('preSelectedOutletId')
        }
      }
    }

    if (isWhiteLabeled) {
      validateStoredOutletId()
    }
  }, [dispatch, isWhiteLabeled])

  return (
    <Page
      title={!isWhiteLabeled ? t('title') : undefined}
      description={t('description')}
    >
      <ClientAuthContainer skeleton={<OutletsListPageSkeleton />}>
        {isWhiteLabeled && <CompanySignUpURLFilter />}
        {isClientContextLoading ? (
          <OutletsListPageSkeleton />
        ) : (
          <>
            <Container className={styles.locationSearchContainer}>
              <NavbarOutletSearch isInNavBar={false} />
            </Container>
            <OutletsList />
          </>
        )}
      </ClientAuthContainer>
    </Page>
  )
}

export default OutletsListPage
